export const createPdfBlob = (base64: string) => {
  if (!base64) return null;
  try {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i+=1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/pdf' });
  } catch (error) {
    console.error('Error creating PDF blob:', error);
    return null;
  }
};

export const createPdfUrl = (base64:string) => {
  if (!base64) return '';
  return `data:application/pdf;base64,${base64}`;
};

export const downloadPdfBlob = (blob: Blob | null, filename = 'document.pdf') => {
  if (!blob || typeof document === 'undefined') return false;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.toLowerCase().endsWith('.pdf') ? filename : `${filename}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  return true;
};

export const printPdfBlob = (blob: Blob | null) => {
  if (!blob || typeof document === 'undefined') return false;

  const url = URL.createObjectURL(blob);
  const frame = document.createElement('iframe');
  frame.setAttribute('aria-hidden', 'true');
  frame.style.position = 'fixed';
  frame.style.right = '0';
  frame.style.bottom = '0';
  frame.style.width = '1px';
  frame.style.height = '1px';
  frame.style.border = '0';
  frame.style.opacity = '0';
  frame.src = url;

  const cleanup = () => {
    frame.remove();
    URL.revokeObjectURL(url);
  };

  frame.onload = () => {
    try {
      frame.contentWindow?.focus();
      frame.contentWindow?.print();
    } finally {
      window.setTimeout(cleanup, 30000);
    }
  };

  document.body.appendChild(frame);
  return true;
};

export const downloadPdfBase64 = (base64: string, filename = 'document.pdf') =>
  downloadPdfBlob(createPdfBlob(base64), filename);

export const printPdfBase64 = (base64: string) => printPdfBlob(createPdfBlob(base64));
